import React from "react";
import { PanelEditSkypeGroup } from "../../../../UI/Groups/Skype/Edit/PanelEditSkypeGroup";

const EditSkypeGroup = () => {
  return (
    <div>
      <PanelEditSkypeGroup />
    </div>
  );
};

export default React.memo(EditSkypeGroup);
